module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate2_m_en.8e5ff3f829912c26bce3cf6c71372357.png";